import axios from "axios";
import { API_URL } from "../apiConfig";
import { compressUploadImage } from "../utils/compressUploadImage";

const TOKEN_KEY = "kataloji_admin_token";

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function adminHeaders() {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function adminLogin(email, password) {
  const res = await axios.post(`${API_URL}/admin/login`, { email, password });
  if (res.data?.access_token) setAdminToken(res.data.access_token);
  return res.data;
}

export async function adminGet(path, params) {
  const res = await axios.get(`${API_URL}/admin${path}`, {
    headers: adminHeaders(),
    params,
  });
  return res.data;
}

export async function adminPost(path, body) {
  const res = await axios.post(`${API_URL}/admin${path}`, body, {
    headers: adminHeaders(),
  });
  return res.data;
}

export async function adminPatch(path, body) {
  const res = await axios.patch(`${API_URL}/admin${path}`, body, {
    headers: adminHeaders(),
  });
  return res.data;
}

export async function adminPut(path, body) {
  const res = await axios.put(`${API_URL}/admin${path}`, body, {
    headers: adminHeaders(),
  });
  return res.data;
}

export async function adminUploadAsset(userId, kind, file) {
  const prepared =
    file && String(file.type || "").startsWith("image/")
      ? await compressUploadImage(file, { maxBytes: 900 * 1024, maxEdge: kind === "hero" ? 2200 : 1200 })
      : file;
  const form = new FormData();
  form.append("kind", kind);
  form.append("file", prepared);
  const res = await axios.post(`${API_URL}/admin/users/${userId}/upload`, form, {
    headers: {
      ...adminHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export function adminLogout() {
  setAdminToken(null);
}

/** Build a correct absolute catalog URL (avoids broken relative links in /admin). */
export function publicCatalogUrl(item) {
  if (!item) return null;
  const path = item.catalog_path;
  if (path && typeof path === "string") {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "";
    return origin ? `${origin}${path.startsWith("/") ? path : `/${path}`}` : path;
  }
  const raw = String(item.catalog_url || "").trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/")) {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "";
    return origin ? `${origin}${raw}` : raw;
  }
  return `${typeof window !== "undefined" ? window.location.protocol : "https:"}//${raw.replace(/^\/+/, "")}`;
}
